import { Scrollbar } from '@repo/go-ui';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { AdditionalDirectoryService } from 'src/services/directory-service';
import type { DirectoryRecord } from 'src/services/directory-service/entities/directory-record.entity';

import { FormControl } from './form-control';

import styles from './sidebar-form.module.scss';

type Props = {
  directory: AdditionalDirectoryService;
  record: DirectoryRecord;
};

export const Form = wrap<Props>(function Form({ directory, record }) {
  const { t } = useTranslation();

  return (
    <Scrollbar>
      {directory.view.groups.map((group, index) => {
        return (
          <div key={index} className={styles.group}>
            {group.title && <p>{t(`labels:${group.title}.label`)}</p>}
            {group.columns.map((column, index) => {
              return (
                <div key={index} className={styles.column}>
                  {column.title && <p>{t(`labels:${column.title}.label`)}</p>}
                  <div className={styles.columnItemsWrapper}>
                    {column.rows.map((controlView) => {
                      return (
                        <FormControl
                          key={controlView.attrName}
                          controlView={controlView}
                          data={directory.record.data}
                          optionsService={directory.optionsService}
                          required={directory.view.required.includes(controlView.fieldId)}
                          onChange={directory.onValueChange}
                          onBlur={directory.onControlBlur}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </Scrollbar>
  );
});
